import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';

@Component( {
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
} )
export class HeaderComponent implements OnInit {
  open: boolean;
  link = {
    FACEBOOK: 'https://www.facebook.com/app.chambea',
    INSTAGRAM: 'https://www.instagram.com/chambea.app/',
    YOUTUBE: null,
    APPSTORE: 'https://apps.apple.com/us/app/chambea/id1556073516',
    GOOGLEPLAY: 'https://play.google.com/store/apps/details?id=com.peruapps.chambea&hl=es_PE&gl=US',
  };

  constructor( private activatedRoute: ActivatedRoute,
               private router: Router, ) { }

  ngOnInit(): void {
  }

  scrollTo( fragment: string ) {
    this.open = false;
    console.log( this.router.url );
    if ( this.router.url === '/' || this.router.url.includes( '/#' ) ) {
      const elmnt = document.getElementById( fragment );
      elmnt.scrollIntoView();
    } else {
      this.router.navigate( ['/'], { fragment } );
    }

  }


  protected readonly environment = environment;
}
